import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useMediaQuery } from '../../../utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProfileCardWrapper = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    marginBlockEnd: "0",
    paddingBlock: isTablet ? '500' : '1000',
    paddingInline: isTablet ? '500' : '1000'
  }, props, {
    children: children
  }));
};